import { DataTable } from '@/components/ui/data-table'
import { useInstalledMigrationsTable } from '@/hooks/useInstalledBlueprintsTable'

type BlueprintListProps = {
  organizationId?: string
  disabled?: boolean
}

const MigrationsList = ({ organizationId }: BlueprintListProps) => {
  const { columns, data, isLoading } =
    useInstalledMigrationsTable(organizationId)

  return (
    <>
      <DataTable
        columns={columns}
        data={data}
        isLoading={isLoading}
        tableConfigName="Migration"
        toolbarProps={{
          allowInstall: true
        }}
      />
    </>
  )
}

export default MigrationsList
